import { Reveal } from "./Reveal";

const GROUPS = [
  { title: "Programming Languages", items: ["C", "C++", "Java", "Python"], testid: "skills-languages" },
  {
    title: "Computer Science",
    items: ["Data Structures & Algorithms", "Object-Oriented Programming", "Database Management Systems"],
    testid: "skills-cs",
  },
];

export const Skills = () => (
  <section id="skills" data-testid="skills-section" className="py-24 md:py-32 border-t border-white/10">
    <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-[#71717A] font-mono-alt">Technical Skills</p>
        <h2 className="font-heading text-4xl md:text-5xl tracking-tight leading-tight font-medium text-[#F9F9F9] mt-4">
          Tools of the trade.
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-12 max-w-3xl">
        {GROUPS.map((g, gi) => (
          <Reveal key={g.title} delay={gi * 0.08}>
            <div data-testid={g.testid}>
              <h3 className="text-xs uppercase tracking-[0.2em] text-[#0EA5E9] font-mono-alt pb-4 border-b border-white/10">
                {g.title}
              </h3>
              <ul className="mt-5 space-y-3">
                {g.items.map((item) => (
                  <li
                    key={item}
                    className={`font-heading text-lg md:text-xl font-medium ${
                      g.editable ? "text-[#71717A] italic text-base" : "text-[#F9F9F9]"
                    }`}
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
